<template>
  <div>
    <HeroBanner
      :page="'leaderboard'"/>
    <Leaderboard/>
    <LoggedInDisplayer/>
  </div>
</template>

<script>
import LoggedInDisplayer from '@/components/LoggedInDisplayer'
import HeroBanner from '@/components/HeroBanner'
import Leaderboard from '@/components/Leaderboard'
export default {
  components: {
    LoggedInDisplayer,
    HeroBanner,
    Leaderboard
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/PageLeaderBoard.vue